// src/components/Home.tsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { useNotifications } from '../NotificationContext';
import { Link } from 'react-router-dom';
import { BASE_URI } from '../Config';


interface UserInfo {
    id: string,
    created_at: string,
    name: string,
    email: string,
    institution: string,
    email_verified: Boolean,
    role: string
}

const Admin: React.FC = () => {
    const { userToken, userVerified, userRole } = useAuth();
    const [users, setUsers] = useState<UserInfo[]>([]);
    const [editedRoles, setEditedRoles] = useState<{ [key: string]: string }>({});
    const { pushMessage } = useNotifications();


    // Mock API call
    const fetchUsers = async () => {
        // await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate network delay
        try {
            const response = await fetch(`${BASE_URI}/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`
                }
            });

            const data = await response.json();

            if (data.users) {
                console.log("Retrieved jobs successful!");
                console.log(data);
                setUsers(data.users);
                // Redirect or perform other actions after successful signup

            } else {
                console.log("Retrieved jobs failed!");
            }
        } catch (error) {
        }
        
    };

    useEffect(() => {

        fetchUsers();
    }, [userToken]);

    const handleRoleChange = (userId: string, newRole: string) => {
        setEditedRoles(prevRoles => ({ ...prevRoles, [userId]: newRole }));
    };

    const handleEdit = async (userId: string) => {
        const role = editedRoles[userId];
        if (!role) return;

        try {
            console.log(JSON.stringify({ id: userId, role }));
            const response = await fetch(`${BASE_URI}/users/edit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`
                },
                body: JSON.stringify({id: userId, role})
            });
    
            const data = await response.json();

            console.log(data);
    
            if (data.success) {
                pushMessage({text: "User updated", type: "notification"});
                fetchUsers();

                // Handle success, maybe update local state or show a message
            } else {
                // Handle failure, maybe show an error message
                pushMessage({text: "Problem updating user", type: "error"});

            }
        } catch (error) {
            console.error("Error updating user role:", error);
            pushMessage({text: "Problem updating user", type: "error"});

        }
    };


    if (userRole != "Admin") {
        return <div id="content-pane">
            Unauthorized.
            </div>;
    }

    return (
        <div>
            <div id="content-pane">
            <table id="user-admin">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Institution</th>
                        <th>Verified</th>
                        <th>Role</th>
                        <th>View</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.id}>
                            <td>{user.created_at.slice(0,-7)}</td>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.institution}</td>
                            <td>{String(user.email_verified)}</td>
                            <td>
                                <select value={editedRoles[user.id] || user.role} onChange={e => handleRoleChange(user.id, e.target.value)}>
                                    <option value="KnownInstitution">Known Institution</option>
                                    <option value="Admin">Admin</option>
                                    <option value="Vcreate">Vcreate</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Unapproved">Unapproved</option>
                                </select>
                            </td>
                            <td><Link to={"/users/"+user.id}>Link</Link></td>
                            <td>{editedRoles[user.id] && editedRoles[user.id] != user.role && <button onClick={() => handleEdit(user.id)}>Edit</button>}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
}

export default Admin;
